module.exports = __webpack_public_path__ + "static/media/quotes.c25cae43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quotes.svg
// module id = 343
// module chunks = 0